import React from "react";
import { Select } from "antd";
const { Option } = Select;

export default function SupervisorSelect({ supervisors, loading, onChange, value }) {
  return (
    <Select
      placeholder="Selecciona un supervisor"
      showSearch
      filterOption={(input, option) => {
        if (!option?.children || typeof option.children !== "string") {
          return false;
        }
        return option.children.toLowerCase().includes(input.toLowerCase());
      }}
      onChange={onChange}
      loading={loading}
      style={{ width: 300 }}
      value={value}
    >
      {supervisors.map((supervisor) => (
        <Option key={supervisor.id} value={supervisor.id}>
          {`${supervisor.first_name} ${supervisor.last_name}`}
        </Option>
      ))}
    </Select>
  );
} 